export default {
    isOpen: false,
    isLoading: false,
    appointmentId: null,
    appointment: {},
    report: {},
    actionWithReason: {
        isOpen: false,
        action: null,
        reason: '',
        errors: {},
    },
    errors: {},
    examples: {},
    isUploading: false,
    damageOpen: null,
    testOpen: null,
    noteOpen: null,
    confirmation: {
        isOpen: false,
        title: '',
        text: '',
        accept: null,
        acceptText: null,
        cancel: null,
        cancelText: null,
    },
};
